// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeader_wrapper__DgTim","searchBox":"PageHeader_searchBox__2am5l"};